export const DarklySharedKeys = {
  LaunchDarklyStore: {id: 'LaunchDarklyStore', defaultValue: {}},
};
